import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ScreenSideNavbarSettings {
  enabled?: boolean;
  visible?: boolean;
  hidden?: boolean;
  brandName?: string;
  brandLabel?: string;
  dockBrandName?: string;
  dockBrandLabel?: string;
  logoText?: string;
  title?: string;
  name?: string;
  include?: string[];
  items?: string[];
  visibleItems?: string[];
  moduleKeys?: string[];
  paths?: string[];
  names?: string[];
  exclude?: string[];
  hiddenItems?: string[];
  excludedItems?: string[];
}

@Injectable({ providedIn: 'root' })
export class ScreenNavigationService {
  private readonly sideNavbarSubject = new BehaviorSubject<ScreenSideNavbarSettings | null>(null);

  readonly sideNavbar$ = this.sideNavbarSubject.asObservable();

  setSideNavbar(settings: ScreenSideNavbarSettings | null): void {
    this.sideNavbarSubject.next(settings);
  }

  clearSideNavbar(): void {
    this.sideNavbarSubject.next(null);
  }
}
